// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './styles/index.scss';
import './css/tailwind.css';

import Vue from 'vue';
import App from './App';
import router from './router';
import PortalVue from 'portal-vue';
import Vuex from 'vuex';
import { store } from './services/store';
import { firebase } from './services/firebase';
import auth from './services/auth';
import { firestorePlugin } from 'vuefire';
import linkify from 'vue-linkify';
import Buefy from 'buefy';

Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.use(Vuex);
Vue.use(Buefy, {
  defaultIconPack: 'fa'
});
Vue.use(firestorePlugin);
Vue.directive('linkified', linkify);

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    await auth.authenticateFirebase();
  }

  // eslint-disable-next-line
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });
});



// WEBPACK FOOTER //
// ./src/main.js